import React from 'react';
import { useTranslation } from 'react-i18next';
import { ThemeType } from '../../../types/command';
import {
  FooterContainer,
  FooterContent,
  FooterBrand,
  FooterPrompt,
  FooterColumn,
  FooterLink,
  FooterBottom,
} from '../styles';

interface FooterProps {
  themeName: ThemeType;
  onSwitchToHome: () => void;
  onSwitchToClassic: () => void;
  onSwitchToTerminal: () => void;
}

const Footer: React.FC<FooterProps> = ({ themeName, onSwitchToHome, onSwitchToClassic, onSwitchToTerminal }) => {
  const { t, i18n } = useTranslation();
  const isEn = i18n.language === 'en';

  return (
    <FooterContainer $themeName={themeName}>
      <FooterContent>
        <FooterBrand $themeName={themeName}>
          <h3>Anıl Orhan</h3>
          <p>{t('services.description')}</p>
          <FooterPrompt $themeName={themeName}>$ echo "let's connect"</FooterPrompt>
        </FooterBrand>
        <FooterColumn $themeName={themeName}>
          <h4>{isEn ? 'Navigate' : 'Sayfalar'}</h4>
          <FooterLink $themeName={themeName} href="#" onClick={(e) => { e.preventDefault(); onSwitchToHome(); }}>
            {isEn ? 'Home' : 'Ana Sayfa'}
          </FooterLink>
          <FooterLink $themeName={themeName} href="#" onClick={(e) => { e.preventDefault(); onSwitchToClassic(); }}>
            {isEn ? 'Portfolio' : 'Portfolyo'}
          </FooterLink>
          <FooterLink $themeName={themeName} href="#" onClick={(e) => { e.preventDefault(); onSwitchToTerminal(); }}>
            Terminal
          </FooterLink>
        </FooterColumn>
        <FooterColumn $themeName={themeName}>
          <h4>{isEn ? 'Connect' : 'Bağlantı'}</h4>
          <FooterLink $themeName={themeName} href="https://github.com/Anil-Orhan" target="_blank" rel="noopener noreferrer">
            GitHub
          </FooterLink>
          <FooterLink $themeName={themeName} href="https://www.linkedin.com/in/anılorhan/" target="_blank" rel="noopener noreferrer">
            LinkedIn
          </FooterLink>
          <FooterLink $themeName={themeName} href="https://twitter.com/anilorhandev" target="_blank" rel="noopener noreferrer">
            Twitter
          </FooterLink>
        </FooterColumn>
      </FooterContent>
      <FooterBottom $themeName={themeName}>
        {t('ClassicPage.footer.text')}
      </FooterBottom>
    </FooterContainer>
  );
};

export default Footer;
